export default __webpack_public_path__ + "static/media/Wawanesa_Assurance_grey.ea2f1ebd.svg";